import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

// SimpleBar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { Link, useLocation } from "react-router-dom";

// i18n
import { withTranslation } from "react-i18next";

import generalSettingIcon from "../../assets/img/general-setting-icon.png";
import connectEmailIcon from "../../assets/img/connect-email-icon.png";
import emailTemplateIcon from "../../assets/img/email-template-icon.png";
import customerSupportIcon from "../../assets/img/customer-support-icon.png";
import objectIcon from "../../assets/img/object-icon.png";
import userIcon from "../../assets/img/user-icon.png";

const SettingSidebar = props => {
  const location = useLocation();
  const refDiv = useRef(null);

  /* -------------------- Init Menu -------------------- */

  useEffect(() => {
    initMenu();
    // eslint-disable-next-line 
  }, [location.pathname, props.type]);

  const initMenu = () => {
    new MetisMenu("#side-menu");

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    if (!ul) return;

    const items = ul.getElementsByTagName("a");
    for (let i = 0; i < items.length; ++i) {
      if (location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  };

  /* -------------------- Helpers -------------------- */

  const scrollElement = item => {
    setTimeout(() => {
      if (refDiv.current && item) {
        const currentPosition = item.offsetTop;
        if (currentPosition > window.innerHeight) {
          refDiv.current.getScrollElement().scrollTop =
            currentPosition - 300;
        }
      }
    }, 300);
  };

  const activateParentDropdown = item => {
    item.classList.add("active");
    const parent = item.parentElement;

    const parent2El = parent?.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm2-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");
        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm2-active");
          parent3.childNodes[0]?.classList.add("mm2-active");

          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0]?.classList.add("mm2-active");
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }

    scrollElement(item);
    return false;
  };

  const userModule = localStorage.getItem("userModule") || "";

  /* -------------------- Render -------------------- */

  return (
    <React.Fragment>
      <SimpleBar className="h-100 project-bar" ref={refDiv}>
        <div id="sidebar-menu" className="setting-menu">
          <ul
            className="metismenu list-unstyled setting-page"
            id="side-menu"
          >
            <li>
              <Link to="/setting/general/calendar">
                <img
                  src={generalSettingIcon}
                  style={{ width: 24 }}
                  className="me-2"
                  alt=""
                />
                <span>{props.t("General Setting")}</span>
              </Link>
            </li>

            <li>
              <Link to="/setting/general/connect-email">
                <img
                  src={connectEmailIcon}
                  style={{ width: 24 }}
                  className="me-2"
                  alt=""
                />
                <span>{props.t("Connect Emails")}</span>
              </Link>
            </li>

            <li>
              <Link to="/setting/email-templates/all">
                <img
                  src={emailTemplateIcon}
                  style={{ width: 24 }}
                  className="me-2"
                  alt=""
                />
                <span>{props.t("Email Templates")}</span>
              </Link>
            </li>

            <li>
              <Link to="/setting/custom-email-template">
                <img
                  src={emailTemplateIcon}
                  style={{ width: 24 }}
                  className="me-2"
                  alt=""
                />
                <span>{props.t("Custom Templates")}</span>
              </Link>
            </li>

            <li>
              <Link to="/setting/customer-support">
                <img
                  src={customerSupportIcon}
                  style={{ width: 24 }}
                  className="me-2"
                  alt=""
                />
                <span>{props.t("Customer Support")}</span>
              </Link>
            </li>

            {/* ---------------- Object Menu ---------------- */}

            <li className="mm-data">
              <Link to="/" className="has-arrow">
                <img
                  src={objectIcon}
                  style={{ width: 24 }}
                  className="me-2"
                  alt=""
                />
                <span>{props.t("Object")}</span>
              </Link>

              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/" className="has-arrow">
                    {props.t("Contact")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/setting/object/contact-level">
                        {props.t("Contact Level")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/contact-status">
                        {props.t("Contact Status")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/contact-type">
                        {props.t("Contact Type")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/" className="has-arrow">
                    {props.t("Lead")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/setting/object/lead-source">
                        {props.t("Sources")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/lead-status">
                        {props.t("Status")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/lead-type">
                        {props.t("Types")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/lead-stage">
                        {props.t("Stage")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/setting/object/note-type">
                    {props.t("Note Types")}
                  </Link>
                </li>

                <li>
                  <Link to="/" className="has-arrow">
                    {props.t("Pre-construction")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/setting/object/project-doc-type">
                        {props.t("Project Document Types")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/project-status">
                        {props.t("Project Status")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/project-type">
                        {props.t("Project Type")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/" className="has-arrow">
                    {props.t("Clients")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/setting/object/transaction-type">
                        {props.t("Transaction Type")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/transaction-comm-type">
                        {props.t("Transaction Commission Type")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/transaction-ref-type">
                        {props.t("Transaction Reference Type")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/transaction-status-type">
                        {props.t("Transaction Status Type")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/listing-type">
                        {props.t("Listing Type")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/listing-status">
                        {props.t("Listing Status")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/service-type">
                        {props.t("Service Type")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/offer-condition">
                        {props.t("Offer Condition")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/setting/object/deal-checklist">
                        {props.t("Deals Checklist")}
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SettingSidebar.propTypes = {
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withTranslation()(SettingSidebar);
